import React, { useEffect, useState } from 'react';
import Highcharts, { charts } from 'highcharts';
import FcModuleStyle from '../styles/fc.module.css';

require('highcharts/modules/accessibility')(Highcharts);
require('highcharts/modules/pattern-fill.js')(Highcharts);

// require('highcharts/modules/mouse-wheel-zoom.js')(Highcharts);
/*const DropDownMonthRange=({simObj}) =>{
  const handleMonthRangeChange = (event) => {
      console.log(simObj?.graphdata)
  }
  return (
<div className={`${FcModuleStyle['Demand-graph-dropdown']}`}>
    <label htmlFor="monthSelector">Select Month Range: </label>
    <select id="monthSelector" onChange={handleMonthRangeChange} className={`ui dropdown ${FcModuleStyle.ui} ${FcModuleStyle.dropdown}`}>
      <option data-value="6" active selected>Last 6 Months</option>
      <option data-value="12">Last 12 Months</option>
      <option data-value="24">Last 24 Months</option>
    </select>
  </div>
  );
}*/
const InventoryGraph = ({ simObj, isResult, setSimObj, summaryGraphData }) => {
  const [chart, setChart] = useState(null);
  const [DemandData, setDemandData] = useState({ "REGULAR": [], "MIDGRADE": [], "PREMIUM": [] });
  const [currStep, setCurrStep] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState(6);
  const [isOptionsUpdated,setIsOptionsUpdated] = useState(false)
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change OM-620
  let currRageObj = {}

  const [monthRange, setMonthRange] = useState({ month_6_Range: [], month_12_Range: [], month_24_Range: [] })

  const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = { year: 'numeric', month: 'long' };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      dateObject = new Date(date.replace(/-/g, "/"));
    }
    return dateObject.toLocaleDateString(navigator.language, options);
  }
  const getMonthDays = (year, month) => {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  const setGraphData = () => {
    if (chart != undefined) {
      let RegularForecastData;
      let RegularActualData;
      let MidgradeForecastData;
      let MidgradeActualData;
      let PremiumForecastData;
      let PremiumActualData;
      (chart && chart?.yAxis && chart?.yAxis[0]) && chart?.yAxis[0]?.update({ min: 0, max: undefined });

      //RegularForcast
      RegularForecastData = simObj?.graphdata;
      RegularForecastData = (RegularForecastData != undefined ? RegularForecastData : []).map((data) => {
        return {
          x: data?.cr,
          y: data?.fi?.REGULAR?.forecastDemand,
          date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
          RegularFDemand: data?.fi?.REGULAR?.forecastDemand
        }
      });
      RegularForecastData.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setDemandData(prevData => ({
        ...prevData,
        REGULAR: RegularForecastData,
      }));

      if (RegularForecastData.length != (chart?.series && Array.isArray(chart.series) && chart?.series[0]?.data?.length)) {
        chart?.series && Array.isArray(chart.series) && chart?.series[0]?.setData(RegularForecastData);
      }

      //RegularActualData
      RegularActualData = simObj?.graphdata;
      RegularActualData = (RegularActualData != undefined ? RegularActualData : []).map((data) => {
        return {
          x: data?.cr,
          y: data?.fi?.REGULAR?.actualDemand,
          date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
          RegularADemand: data?.fi?.REGULAR?.actualDemand
        }
      });
      RegularActualData.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setDemandData(prevData => ({
        ...prevData,
        REGULAR: RegularActualData
      }));
      if (RegularActualData.length != (chart?.series && Array.isArray(chart.series) && chart?.series[1]?.data?.length)) {
        chart?.series && Array.isArray(chart.series) && chart?.series[1]?.setData(RegularActualData);
      }

      if(simObj?.optionsAvailable?.MIDGRADE){
      //MidgradeForcast
        MidgradeForecastData = simObj?.graphdata;
        MidgradeForecastData = (MidgradeForecastData != undefined ? MidgradeForecastData : []).map((data) => {
          return {
            x: data?.cr,
            y: data?.fi?.MIDGRADE?.forecastDemand,
            date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
            MidgradeFDemand: data?.fi?.MIDGRADE?.forecastDemand
          }
        });
        MidgradeForecastData.sort((a, b) => {
          return new Date(a.date) - new Date(b.date);
        });
        setDemandData(prevData => ({
          ...prevData,
          MIDGRADE: MidgradeForecastData,
        }));
        if (MidgradeForecastData.length != (chart?.series && Array.isArray(chart.series) && chart?.series[2]?.data?.length)) {
          chart?.series && Array.isArray(chart.series) && chart?.series[2]?.setData(MidgradeForecastData);
        }

      //MidgradeActualData
      MidgradeActualData = simObj?.graphdata;
      MidgradeActualData = (MidgradeActualData != undefined ? MidgradeActualData : []).map((data) => {
        return {
          x: data?.cr,
          y: data?.fi?.MIDGRADE?.actualDemand,
          date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
          MidgradeADemand: data?.fi?.MIDGRADE?.actualDemand
        }
      });
      MidgradeActualData.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setDemandData(prevData => ({
        ...prevData,
        MIDGRADE: MidgradeActualData
      }));

      if (MidgradeActualData.length != (chart?.series && Array.isArray(chart.series) && chart?.series[3]?.data?.length)) {
        chart?.series && Array.isArray(chart.series) && chart?.series[3]?.setData(MidgradeActualData);
      }
    }

    if(simObj?.optionsAvailable?.PREMIUM){
      //PremiumForcast
      PremiumForecastData = simObj?.graphdata;
      PremiumForecastData = (PremiumForecastData != undefined ? PremiumForecastData : []).map((data) => {
        return {
          x: data?.cr,
          y: data?.fi?.PREMIUM?.forecastDemand,
          date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
          PremiumFDemand: data?.fi?.PREMIUM?.forecastDemand
        }
      });
      PremiumForecastData.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setDemandData(prevData => ({
        ...prevData,
        PREMIUM: PremiumForecastData,
      }));
      if (PremiumForecastData.length != (chart?.series && Array.isArray(chart.series) && chart?.series[4]?.data?.length)) {
        chart?.series && Array.isArray(chart.series) && chart?.series[4]?.setData(PremiumForecastData);
      }

      //PremiumActualData
      PremiumActualData = simObj?.graphdata;
      PremiumActualData = (PremiumActualData != undefined ? PremiumActualData : []).map((data) => {
        return {
          x: data?.cr,
          y: data?.fi?.PREMIUM?.actualDemand,
          date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
          PremiumADemand: data?.fi?.PREMIUM?.actualDemand
        }
      });
      PremiumActualData.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setDemandData(prevData => ({
        ...prevData,
        PREMIUM: PremiumActualData
      }));

      if (PremiumActualData.length != (chart?.series && Array.isArray(chart.series) && chart?.series[5]?.data?.length)) {
        chart?.series && Array.isArray(chart.series) && chart?.series[5]?.setData(PremiumActualData);
      }
    }

    }
    (simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && (chart && chart?.yAxis && chart?.yAxis[0]) && chart?.yAxis[0].update({ min: 1, max: 1000 })
    let gdataLen = simObj?.graphdata?.length;
    let month_6_Range = [];
    let month_12_Range = [];
    let month_24_Range = [];
    if (gdataLen != undefined && gdataLen != 0) {

      //switch (selectedMonth) {
      //case 6:
      if (gdataLen >= 1) {
        month_6_Range.push({ min: 1, max: 6 })
      }
      if (gdataLen >= 7) {
        month_6_Range.push({ min: 7, max: 12 })
      }
      if (gdataLen >= 13) {
        month_6_Range.push({ min: 13, max: 18 })
      }
      if (gdataLen >= 19) {
        month_6_Range.push({ min: 19, max: 24 })
      }
      //break;
      //case 12:
      if (gdataLen >= 1) {
        month_12_Range.push({ min: 1, max: 12 })
      }
      if (gdataLen >= 13) {
        month_12_Range.push({ min: 13, max: 24 })
      }
      // break;
      //case 24:
      if (gdataLen >= 1) {
        month_24_Range.push({ min: 1, max: 24 })
      }
      //break;
      // default:
      // break;
      // }
     
      setMonthRange((prevMonthRange) => {
        return {
          ...prevMonthRange,
          ['month_6_Range']: [...month_6_Range],
          ['month_12_Range']: [...month_12_Range],
          ['month_24_Range']: [...month_24_Range]
        }
      })
    }
    else{
      //if (gdataLen != undefined || gdataLen.length == 0) {
        month_6_Range.push({ min: 1, max: 6 })
        month_12_Range.push({ min: 1, max: 12 })
        month_24_Range.push({ min: 1, max: 24 })
      //}
    }
  }

  const updateSeriesBasedOnWindowWidth = () => {
    const windowWidth = window.innerWidth;
    if (chart != undefined && chart?.series && chart?.series?.length>0) {
      // debugger;
      if (windowWidth >= 1217) {
        if(chart?.series?.length > 0 ){
          chart?.series != undefined && chart?.series[0].update({
            pointWidth: 20
          });
          chart?.series != undefined && chart?.series[1].update({
            pointWidth: 5
          });
        }
        if(chart?.series?.length >2 ){
          chart?.series != undefined && chart?.series[2].update({
            pointWidth: 20
          });
          chart?.series != undefined && chart?.series[3].update({
            pointWidth: 5
          });
        }
        if(chart?.series?.length == 6 ){
          chart?.series != undefined && chart?.series[4].update({
            pointWidth: 20
          });
          chart?.series != undefined && chart?.series[5].update({
            pointWidth: 5
          });
        }
      } 
      // else if (windowWidth <= 1216) {
      //   chart?.series != undefined && chart?.series[0].update({
      //     //pointWidth: 4
      //   });
      //   chart?.series != undefined && chart?.series[1].update({
      //     //pointWidth: 4
      //   });
      //   chart?.series != undefined && chart?.series[2].update({
      //     //pointWidth: 4
      //   });
      //   chart?.series != undefined && chart?.series[3].update({
      //     //pointWidth: 4
      //   });
      //   chart?.series != undefined && chart?.series[4].update({
      //     //pointWidth: 4
      //   });
      //   chart?.series != undefined && chart?.series[5].update({
      //     //pointWidth: 4
      //   });
        //   chart.update({
        //     chart: {
        //         zoomType: null // or 'x' or 'y' based on your requirement
        //     }
        // });
      // }
    }
  }


  const getNextMonthRange = () => {
    setCurrStep(currStep + 1);
    // currStep = currStep + 1;
    currRageObj = monthRange[eval(['month_' + selectedMonth + '_Range'])][currStep + 1];
    chart?.xAxis[0]?.setExtremes(currRageObj?.min, currRageObj?.max);
  }
  const getprevMonthRange = () => {
    setCurrStep(currStep - 1);
    //  currStep = currStep - 1;
    currRageObj = monthRange[eval(['month_' + selectedMonth + '_Range'])][currStep - 1];
    chart?.xAxis[0]?.setExtremes(currRageObj?.min, currRageObj?.max);
  }

  const handleMonthRangeChange = (event) => {
    let currMonthRange = parseInt(event?.target?.value, 10);
    setSelectedMonth(currMonthRange);
    setCurrStep(0);
    switch (currMonthRange) {
      case 6:
        if (currMonthRange == "6" && !0) {

          currRageObj = monthRange[eval(['month_' + currMonthRange + '_Range'])][0];

          if (chart && chart.xAxis && chart.xAxis[0]) {
            chart?.xAxis[0]?.setExtremes(currRageObj?.min, currRageObj?.max);
          }

          for (var i = 0; i < 6; i++) {
            let pw = i % 2 == 0 ? 20 : 5;
            chart?.series && Array.isArray(chart.series) && chart.series[i]?.update({
              pointWidth: pw,
            });
          }


        }
        break;
      case 12:
        if (currMonthRange == "12" && !0) {

          currRageObj = monthRange[eval(['month_' + currMonthRange + '_Range'])][0];
          if (chart && chart.xAxis && chart.xAxis[0]) {
            chart?.xAxis[0]?.setExtremes(currRageObj?.min, currRageObj?.max);
          }

          for (var i = 0; i < 6; i++) {
            let pw = i % 2 == 0 ? 10 : 4;
            chart?.series && Array.isArray(chart.series) && chart.series[i]?.update({
              pointWidth: pw,
            });
          }


        }
        break;
      case 24:
        if (currMonthRange == "24" && !0) {
          currRageObj = monthRange[eval(['month_' + currMonthRange + '_Range'])][0];
          if (chart && chart.xAxis && chart.xAxis[0]) {
            chart?.xAxis[0]?.setExtremes(currRageObj?.min, currRageObj?.max);
          }

          for (var i = 0; i < 6; i++) {
            let pw = i % 2 == 0 ? 6 : 2;
            chart?.series && Array.isArray(chart.series) && chart.series[i]?.update({
              pointWidth: pw,
            });
          }

        }
        break;
      default:
        // Handle the default case or do nothing
        break;
    }
  }

  const InventoryData = {
    "monthly": [],
    "yearly": [],
    "quarterly": []
  }

  function applyDemandAccessibility(chart) {
    if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector('svg');
      if (svg) {
        setTimeout(() => {
          const levels = ["Regular"]; // Regular always exists
          if (simObj?.optionsAvailable?.MIDGRADE) {
            levels.push("Midgrade");
          }
          if (simObj?.optionsAvailable?.PREMIUM) {
            levels.push("Premium");
          }

          const levelsText = levels.join(", ");


          svg.setAttribute('role', 'img');
          svg.setAttribute(
            'aria-label',
            `Demand chart comparing forecasted and actual demand for ${levelsText} across months`
          );

          // remove old desc if it exists
          const oldDesc = svg.querySelector('desc');
          if (oldDesc) oldDesc.remove();

          // add new desc
          const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
          desc.textContent =
            `This chart shows the forecasted and actual demand for ${levelsText} for months. Different patterns were used to show the Forecasted demand and actual demand bars.`;
          svg.insertBefore(desc, svg.firstChild);
        }, 0);
      }
    }
  }

  let seriesData = {
    "REGULAR" : [
      {
      name: "Regular - Forecasted demand",
      borderWidth: 0,
      borderRadius: 0,
      legendIndex: 1,
      // states: {
      //   hover: {
      //     borderWidth: 1, // Border width on hover
      //     borderColor: 'black' // Border color on hover
      //   }
      // },
      data: [],
      //color: "#347B8D",
      color: {
        pattern: {
          path: 'M 0 10 L 10 0', // diagonal stripes
          width: 10,
          height: 10,
          color: '#000000',
          backgroundColor: "#faaf5a"

        }
      },
      pointPadding: 0.1,
      pointPlacement: -0.2,
      animation: {
        duration: 1000 // Set a lower duration for the animation
      }

    },
    {
      name: "Regular - Actual demand",
      borderWidth: 0,
      borderRadius: 0,
      legendIndex: 4,
      // states: {
      //   hover: {
      //     borderWidth: 1, // Border width on hover
      //     borderColor: 'black' // Border color on hover
      //   }
      // },
      data: [],
      // color: "#044e61",
      color: {
        patternIndex: 0,
        pattern: {
          width: 10,
          height: 8,
          strokeWidth: 1.5,
          color: '#333333', // medium gray for better grayscale contrast
          backgroundColor: '#f7d7a6'
        }
      },
      pointPadding: 0.4,
      pointPlacement: -0.2,
      animation: {
        duration: 10000, // Set a lower duration for the animation
      }
    }],

    "MIDGRADE":[
    {
      name: "Midgrade - Forecasted demand",
      borderWidth: 0,
      borderRadius: 0,
      legendIndex: 2,
      // states: {
      //   hover: {
      //     borderWidth: 1, // Border width on hover
      //     borderColor: 'black' // Border color on hover
      //   }
      // },
      data: [],
      //color: "#2CAFFE",
      color: {
        pattern: {
          path: 'M 0 0 L 10 10 M 9 - 1 L 11 1 M - 1 9 L 1 11', // crosshatch
          width: 10,
          height: 10,
          color: '#000000',
          backgroundColor: '#f7f77c'
        },
      },
      pointPadding: 0.4,
      pointPlacement: 0.1,
      animation: {
        duration: 1000 // Set a lower duration for the animation
      }
    },
    {
      name: "Midgrade - Actual demand",
      borderWidth: 0,
      borderRadius: 0,
      legendIndex: 5,
      // states: {
      //   hover: {
      //     borderWidth: 1, // Border width on hover
      //     borderColor: 'black' // Border color on hover
      //   }
      // },
      data: [],
      // color: "#1A83CF",
      color: {
        patternIndex: 3,
        pattern: {
          width: 6,
          height: 6,
          color: '#444444',
          backgroundColor: '#d8d4f0'
        }
      },
      pointPadding: 0.4,
      pointPlacement: 0.1,
      animation: {
        duration: 10000, // Set a lower duration for the animation
      }
    }],

    "PREMIUM":[
    {
      name: "Premium - Forecasted demand",
      borderWidth: 0,
      borderRadius: 0,
      legendIndex: 3,
      // states: {
      //   hover: {
      //     borderWidth: 1, // Border width on hover
      //     borderColor: 'black' // Border color on hover
      //   }
      // },
      data: [],
      //color: "#00E272",
      color: {
        pattern: {
          path: 'M 0 5 L 10 5', // horizontal line
          width: 7,
          height: 10,
          color: '#000000',
          backgroundColor: '#e9adf7'
        }
      },
      pointPadding: 0.4,
      pointPlacement: 0.4,
      animation: {
        duration: 1000 // Set a lower duration for the animation
      }
    },
    {
      name: "Premium - Actual demand",
      borderWidth: 0,
      borderRadius: 0,
      legendIndex: 6,
      // states: {
      //   hover: {
      //     borderWidth: 1, // Border width on hover
      //     borderColor: 'black' // Border color on hover
      //   }
      // },
      data: [],
      // color: "#069161",
      color: {
        patternIndex: 1,
        pattern: {
          width: 10,
          height: 10,
          strokeWidth: 1.5,
          color: '#333333',
          backgroundColor: '#b5e8d5'
        }
      },
      pointPadding: 0.4,
      pointPlacement: 0.4,
      animation: {
        duration: 10000, // Set a lower duration for the animation
      }
    }]
  }
  let graphSettings = {
    chart: {
      type: "column",
      height: 300,
      marginBottom: 140,
      plotBorderWidth: 1,
      events: {
        render: function () {
          applyDemandAccessibility(this);
        },
        redraw: function () {
          applyDemandAccessibility(this);
        }
      }
    },

    title: {
      text: null
    },
    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      layout: 'horizontal',
      floating: true,
      visible: true,
      y: -10,
    },

    xAxis: {
      min: 1,
      max: 6,
      categories: ['', 'January 2023', 'February 2023', 'March 2023', 'April 2023', 'May 2023', 'June 2023', 'July 2023', 'August 2023', 'September 2023', 'October 2023', 'November 2023', 'December 2023', 'January 2024', 'February 2024', 'March 2024', 'April 2024', 'May 2024', 'June 2024', 'July 2024', 'August 2024', 'September 2024', 'October 2024', 'November 2024', 'December 2024'],
      step: 1,
      //gridLineWidth: 1.5,
      tickInterval: 1,
      tickLength: 0,
      lineColor: '#C6C6C3',
      title: {
        text: "Month Range",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        },
      },
      labels: {
        rotation: -45,
        step: 1,
        formatter: function () {
          var text = this.value,
            formatted = text.length > 3 ? text.substring(0, 3) : text;
          return '<div style="width:10px; overflow:hidden" title="' + text + '">' + formatted + '</div>';
        },
        style: {
          fontSize: '0.8em'
        }
      }
    },
    yAxis: {
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 4,
      allowDecimals: false,
      gridLineColor: '#C6C6C3',
      gridLineWidth: 1,
      title: {
        text: "Demand",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        },
      },
      // tickInterval: 200,
      //gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0);
        },
      }
    },
    accessibility: {
      enabled: true,
      description: '',
      pointDescriptionFormatter: function (point) {
        // Customize the aria-label for each point
        return `Date: ${point.date}; ${(point.RegularFDemand != undefined) ? `Regular Forecasted Demand: ${point.RegularFDemand};` : ``} ${(point.RegularADemand != undefined) ? `Regular Actual Demand: ${point.RegularADemand};` : ``}  ${(point.MidgradeFDemand != undefined) ? `Midgrade Forecasted Demand: ${point.MidgradeFDemand};` : ``} ${(point.MidgradeADemand != undefined) ? `Midgrade Actual Demand: ${point.MidgradeADemand};` : ``}  ${(point.PremiumFDemand != undefined) ? `Premium Forecasted Demand: ${point.PremiumFDemand};` : ``} ${(point.PremiumADemand != undefined) ? `Premium Actual Demand: ${point.PremiumADemand};` : ``}`;
      },
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      },
       screenReaderSection: {
            beforeChartFormat: '' // disables the default label
        }
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
        //stacking: 'normal',
        dataLabels: {
          enabled: false
        }
      },
      // events: {
      //   legendItemClick: function () {
      //     return false; // Prevent default legend item click behavior
      //   }
      // }
      series: {
        events: {
          legendItemClick: function () {
            let min = this?.chart?.series[2].yAxis.min && this?.chart?.series[2].yAxis.min;
            let max = this?.chart?.series[2].yAxis.max && this?.chart?.series[2].yAxis.max;
            setTimeout(() => {
              (this?.chart?.series && this.chart.series.every(series => !series.visible)) ? (this?.chart && this?.chart?.yAxis && this?.chart?.yAxis[0]) && this?.chart?.yAxis[0].update({ min: min, max: max }) : (this?.chart && this?.chart?.yAxis && this?.chart?.yAxis[0]) && this?.chart?.yAxis[0].update({ min: undefined, max: undefined, tickInterval: null });
            }, 100);
          }
        }
      },
    },
    series: undefined,
    tooltip: {
      /*formatter: function () {
        return '<strong>' + (this.point.date) + '</strong><br/>' +
        this.points.map(point => '<span style="color:' + point.color + ';">●</span> ' + point.series.name + ': <strong>' + Highcharts.numberFormat(point.y, 0, ',', ',')+ '</strong>').join('<br>');
      }*/
      borderWidth: 1,

      formatter: function () {
        var tooltipText = '<strong>' + (this.point.date) + '</strong><br/>';

        if (this.series.name === 'Regular - Forecasted demand' || this.series.name === 'Regular - Actual demand') {
          let seriesToShow = [0, 1]; // Indices of the series to display
          for (var i = 0; i < seriesToShow.length; i++) {
            var seriesIndex = seriesToShow[i];
            var series = this.series.chart.series[seriesIndex];
            if (series) {
              var point = series.points.find(point => point.category === this.point.category);
              if (point) {
                tooltipText += '<span style="color:' + point.color + ';">●</span> ' + series.name + ': <strong style="font-weight: bold;">' + Highcharts.numberFormat(point.y, 0, ',', ',') + '</strong><br/>';
              }
            }
          }
        }
        if (this.series.name === 'Midgrade - Forecasted demand' || this.series.name === 'Midgrade - Actual demand') {
          let seriesToShow = [2, 3]; // Indices of the series to display
          for (let i = 0; i < seriesToShow.length; i++) {
            let seriesIndex = seriesToShow[i];
            let series = this.series.chart.series[seriesIndex];
            if (series) {
              let point = series.points.find(point => point.category === this.point.category);
              if (point) {
                tooltipText += '<span style="color:' + point.color + ';">●</span> ' + series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(point.y, 0, ',', ',') + '</strong><br/>';
              }
            }
          }
        }
        if (this.series.name === 'Premium - Forecasted demand' || this.series.name === 'Premium - Actual demand') {
          let seriesToShow = [4, 5]; // Indices of the series to display
          for (let i = 0; i < seriesToShow.length; i++) {
            let seriesIndex = seriesToShow[i];
            let series = this.series.chart.series[seriesIndex];
            if (series) {
              let point = series.points.find(point => point.category === this.point.category);
              if (point) {
                tooltipText += '<span style="color:' + point.color + ';">●</span> ' + series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(point.y, 0, ',', ',') + '</strong><br/>';
              }
            }
          }
        }

        return tooltipText;
      }
    }
  }

  /*useEffect(() => {
    console.log("monthRage" + JSON.stringify(monthRange))
  }, [monthRange])*/
  useEffect(() => {
    updateSeriesBasedOnWindowWidth();
    window.addEventListener("resize", updateSeriesBasedOnWindowWidth);
    window.addEventListener("load", updateSeriesBasedOnWindowWidth);
  }, [chart]);
  useEffect(() => {
    // Initialize the 
    const newChart = Highcharts.chart("Demand-Graph", graphSettings);
    setChart(newChart);
    window.$('.ui.dropdown').dropdown('set selected', '6').attr('tabindex', '0');
  }, []);

  useEffect(()=>{
    let seriesdata = []
    if(simObj?.optionsAvailable && !isOptionsUpdated){
      // debugger
      for (const key in simObj?.optionsAvailable) {
        if (simObj?.optionsAvailable[key]) {
          seriesdata = [...seriesdata,...seriesData[key]]
        }
      }
      graphSettings.series = seriesdata
      const newChart = Highcharts.chart("Demand-Graph", graphSettings);
      setChart(newChart);
      window.$('.ui.dropdown').dropdown('set selected', '6').attr('tabindex', '0');
      setIsOptionsUpdated(true);
    }
  },[simObj?.optionsAvailable])

  useEffect(() => {
    setGraphData();

    if (chart != undefined) {
      document.querySelector("#Demand-Graph .highcharts-container ").setAttribute('tabindex', '0');
    }
  }, [chart, simObj?.graphdata]);
  // useEffect(() => {
  //   if (isResult) {
  //     setGraphData();
  //   }
  // }, [simObj, isResult, summaryGraphData])
  useEffect(() => {
    const checkStyleTag = () => {
      const styleTag = document.querySelector('style.stylus');
      setIsStyleTagPresent(!!styleTag);  // Updates the state to true if the tag is found, false otherwise
    };

    // Call the check function when the component mounts
    checkStyleTag();

    // Optionally, if the tag might be dynamically added, use a MutationObserver or setInterval
    const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
    return () => clearInterval(intervalId);  // Clean up interval when component unmounts
  }, []);
  useEffect(()=>{
    if(chart != undefined){
      // Update the legend dynamically
      chart.update({
        legend: {
            itemStyle: {
                fontSize: isStyleTagPresent ? '0.7em' : '0.8em',
            },
        },
    });
    }
  },[chart,isStyleTagPresent])

  return (
    <>
     <div className={`${FcModuleStyle['Demand-graph-dropdown']}`}>
        <div className={`${FcModuleStyle['Demand-dropdown-pagination']}`}>
          <label htmlFor="monthSelector">Select Month Range: </label>
          <select id="monthSelector" onChange={handleMonthRangeChange} className={`ui dropdown ${FcModuleStyle.ui} ${FcModuleStyle.dropdown}`}>
            <option value="6" active selected>6 Months</option>
            <option value="12">12 Months</option>
            <option value="24">24 Months</option>
          </select>
        </div>
        {

          <>
            <div className={`${FcModuleStyle['Demand-pagination-container']}`}>
              <button disabled={0 == currStep} className={`${FcModuleStyle['left-arrow']}`} id="prevButton" aria-label="Previous month demand" onClick={getprevMonthRange}><span aria-hidden="true">&#x2C2;&#x2C2;</span> </button>
              <span>&nbsp;</span>
              <button disabled={monthRange['month_' + selectedMonth + '_Range'].length - 1 == currStep} className={`${FcModuleStyle['right-arrow']}`} id="nextButton" aria-label="Next month demand" onClick={getNextMonthRange}> <span aria-hidden="true">&#x2C3;&#x2C3;</span></button>
            </div>
          </>}
      </div>
      <div className={`${FcModuleStyle['graph-container']}`}>
     

      {!simObj?.graphdata?.length && <div className={`${FcModuleStyle['nodata-alert-demand']}`}>Demand will appear here as the simulation runs</div>}
      {/* <a href="#" onClick={(e) => e.preventDefault()} aria-label="Legend: Column for Failure Rate" className="sr-only"></a> */}
      <div id="Demand-Graph" className={`${FcModuleStyle['inventory-graph']}`}></div>
    </div>
    </>
    
  )
}

export default InventoryGraph